import { FC, HTMLAttributes, useEffect, useRef, useState } from "react";
import { Button } from "antd";
import { clsx } from "clsx";
import { useNavigate } from "react-router-dom";
import { getScoreGrade } from "../../../common/Grade";
import { SvgIcon } from "../../../common/components/SvgIcon";
import classes from "./DealScore.module.less";

export interface DealScoreProps extends HTMLAttributes<HTMLDivElement> {
    score: number;
    optimizedScore?: number;
    orderFormId?: number;
}

export const DealScore: FC<DealScoreProps> = ({
    className,
    orderFormId,
    score,
    optimizedScore,
    ...restProps
}) => {
    const navigate = useNavigate();
    const labelRef = useRef<HTMLSpanElement>(null);
    const [labelWidth, setLabelWidth] = useState(0);

    const showNavigation = orderFormId != null;
    const showOptimized = optimizedScore != null && optimizedScore > score;

    const handleNaviation = showNavigation
        ? () => {
              navigate(`/order/score/${orderFormId}`);
          }
        : undefined;

    useEffect(() => {
        if (labelRef.current) {
            setLabelWidth(labelRef.current.offsetWidth);
        }
    }, [score]);

    return (
        <div
            {...restProps}
            className={clsx(
                className,
                classes.dealScore,
                showNavigation && classes.dealScoreWithNavigation
            )}
        >
            {showNavigation && (
                <Button
                    type="primary"
                    size="small"
                    icon={<SvgIcon size={14} name="group" className={classes.negotiationIcon} />}
                    onClick={handleNaviation}
                >
                    Deal score
                </Button>
            )}
            <div className={classes.scoreBarWrapper} onClick={handleNaviation}>
                <div className={classes.scoreBar}>
                    <div
                        className={classes.scoreBarFill}
                        style={{
                            width: `${score}%`,
                            backgroundSize: `${(100 / score) * 100}% 100%`,
                        }}
                    />
                </div>
                {showOptimized && (
                    <div
                        className={classes.optimizedMarker}
                        style={{ left: `${optimizedScore}%` }}
                    />
                )}
                <span
                    ref={labelRef}
                    className={classes.scoreBarLabel}
                    style={{ left: `max(8px, calc(${score}% - ${labelWidth + 10}px))` }}
                >
                    {score}% ({getScoreGrade(score).grade})
                </span>
            </div>
        </div>
    );
};

DealScore.displayName = "DealScore";
